import React from "react";
import { Col, Row } from "react-bootstrap";
import Table from "react-bootstrap/Table";

function MarginStatementDisclaimerNote({  }) {

  return (
      <div className="mt-4 note-disclaimer-container">
        <div className="p-4 tnc-content disable-scroll">
          <div className="text-bold-600">*Notes:</div>
          <b> 1. Any movement of funds & portfolio will only be updated on the
            next business day</b>
        </div>
      </div>
  );
}

export default MarginStatementDisclaimerNote;
